/* 
  单位管理
*/
import request from "@/utils/request";

//获取页面参数
export function getParam() {
  return request({
    url: "/sysmange/school/getParam",
    method: "get"
  });
}

//获取单位管理信息分页列表
export function getSchool(params) {
  return request({
    url: "/sysmange/school/getSchool",
    method: "get",
    params
  });
}

//添加或者编辑单位信息
export function saveOrUpdate(data) {
  return request({
    url: "/sysmange/school/saveOrUpdate",
    method: "post",
    data
  });
}

//删除单位信息
export function deleteSchool(data) {
  return request({
    url: "/sysmange/school/deleteSchool",
    method: "post",
    data
  });
}

//根据市县ID获取单位列表
export function getSchoolByDistrict(districtId: string) {
  return request({
    url: "/sysmange/school/getSchoolByDistrict",
    method: "get",
    params: { districtId }
  });
}